import React, { useState, useEffect } from "react";
import { InputNumber, Table, Button, Select } from "antd";
import { PlusOutlined, MinusCircleOutlined, EditOutlined, CheckOutlined } from "@ant-design/icons";

const { Option } = Select;

const ViewSalaryDetails = ({ employee,payrollStatus, onClose }) => {
  // Default empty object for employee
  const [earnings, setEarnings] = useState([]);
  const [deductions, setDeductions] = useState([]);
  const [lopDays, setLopDays] = useState(0);
  const [payableDays, setPayableDays] = useState(20);
  const [editingDeductionIndex, setEditingDeductionIndex] = useState(null);
  const [editedDeductionAmount, setEditedDeductionAmount] = useState(null);
  const [editingLOP, setEditingLOP] = useState(false);
  // Update state dynamically when employee changes
  useEffect(() => {
    if (employee) {
      setEarnings(employee.salary_breakdown?.earnings || []);
      setDeductions(employee.salary_breakdown?.deductions || []);
      setLopDays(0);
      setPayableDays(employee.payableDays || 20);
    }
  }, [employee]);

  const addEarning = () => {
    setEarnings([...earnings, { head: "", amount: 0, isAdditional: true }]);
  };

  const removeEarning = (index) => {
    setEarnings(earnings.filter((_, idx) => idx !== index));
  };

  const addDeduction = () => {
    setDeductions([...deductions, { head: "", amount: 0, isAdditional: true }]);
  };

  const removeDeduction = (index) => {
    setDeductions(deductions.filter((_, idx) => idx !== index));
  };

  const calculateTotal = (list) => list.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);

  const totalEarnings = calculateTotal(earnings);
  const totalDeductions = calculateTotal(deductions);
  const netPay = totalEarnings - totalDeductions;
  const isReadOnly = payrollStatus === "paid" || payrollStatus === "approved";
  return (
<div
      id="view_salary_details"
      className="modal custom-modal fade custom-modal-width"
      role="dialog"
    >
      <div
        className="modal-dialog modal-lg"
        style={{ margin: 0, position: "fixed", right: 0, height: "100vh", width: "50%" }}
        role="document"
      >
        <div className="modal-content h-100">
          <form className="d-flex flex-column h-100">
            {/* Modal Header */}
            <div className="modal-header">
              <h5 className="modal-title">View Salary Details</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={onClose}
              />
            </div>

            {/* Modal Body */}
            <div className="modal-body" style={{ maxHeight: "calc(100vh - 90px)", overflowY: "auto" }}>
              {/* Employee Info */}
              <div className="row mb-12">
                <div className="col-md-4">
                  <strong>Employee Name:</strong> {employee?.name || "N/A"}
                </div>
                <div className="col-md-4">
                  <strong>Employee ID:</strong> {employee?.empcode || "N/A"}
                </div>
                <div className="col-md-4">
                  <strong>Net Salary:</strong> ₹{netPay.toFixed(2)}
                </div>
              </div>

                {/* Payable Days and LOP */}
                <div className="row mb-3 border-bottom pb-3">
            <div className="col-md-6">
              <strong>Payable Days:</strong> {payableDays}
            </div>
            <div className="col-md-6 d-flex justify-content-end">
              {payrollStatus === "paid" || payrollStatus === "approved" ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <strong>LOP Days:</strong>
                  <span style={{ margin: "0 8px" }}>{lopDays}</span>
                </div>
              ) : (
                editingLOP ? (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <strong>LOP Days:</strong>
                    <InputNumber
                      min={0}
                      value={lopDays}
                      onChange={(value) => {
                        setLopDays(value || 0);
                        setPayableDays((employee?.payableDays || 20) - (value || 0));
                      }}
                      style={{ margin: "0 8px" }}
                    />
                    <Button
                      type="primary"
                      icon={<CheckOutlined />}
                      onClick={() => setEditingLOP(false)}
                    >
                      Save
                    </Button>
                  </div>
                ) : (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <strong>LOP Days:</strong>
                    <span style={{ margin: "0 8px" }}>{lopDays}</span>
                    <Button type="link" icon={<EditOutlined />} onClick={() => setEditingLOP(true)}>
                      Edit
                    </Button>
                  </div>
                )
              )}
            </div>
          </div>

              {/* Earnings Section */}
              <div className="row mb-3 border-bottom pb-3">
                <div className="col-md-12">
                  <h5>Earnings</h5>
                  <Table
                    dataSource={earnings}
                    columns={[
                      {
                        title: "Head",
                        dataIndex: "head",
                        render: (text, record, index) =>
                          record.isAdditional ? (
                            <Select
                              placeholder="Select earning"
                              value={text}
                              onChange={(value) => {
                                const updated = [...earnings];
                                updated[index].head = value;
                                setEarnings(updated);
                              }}
                              style={{ width: "100%" }}
                            >
                              <Option value="Commission">Commission</Option>
                              <Option value="Reimbursement">Reimbursement</Option>
                              <Option value="Leave Encashment">Leave Encashment</Option>
                            </Select>
                          ) : (
                            <span>{text}</span>
                          ),
                      },
                      {
                        title: "Amount",
                        dataIndex: "amount",
                        render: (value, record, index) =>
                          record.isAdditional ? (
                            <InputNumber
                              min={0}
                              value={value}
                              onChange={(val) => {
                                const updated = [...earnings];
                                updated[index].amount = val || 0;
                                setEarnings(updated);
                              }}
                            />
                          ) : (
                            <span>{value.toFixed(2)}</span>
                          ),
                      },
                      {
                        title: "",
                        render: (_, record, index) =>
                          record.isAdditional && (
                            <Button
                              type="link"
                              danger
                              icon={<MinusCircleOutlined />}
                              onClick={() => removeEarning(index)}
                            />
                          ),
                      },
                    ]}
                    rowKey={(record, index) => index}
                    pagination={false}
                  />
       {!(payrollStatus === "paid" || payrollStatus === "approved") && (
                <Button
                  type="dashed"
                  onClick={addEarning}
                  icon={<PlusOutlined />}
                  style={{ marginTop: "10px" }}
                >
                  Add Earning
                </Button>
              )}
                </div>
              </div>

              {/* Deductions Section */}
              <div className="row mb-3 border-bottom pb-3">
                <div className="col-md-12">
                  <h5>Deductions</h5>
                  <Table
                    dataSource={deductions}
                    columns={[
                      {
                        title: "Head",
                        dataIndex: "head",
                      },
                      {
                        title: "Amount",
                        dataIndex: "amount",
                        render: (value, _, index) =>
                          editingDeductionIndex === index ? (
                            <InputNumber
                              min={0}
                              value={editedDeductionAmount || value}
                              onChange={(val) => setEditedDeductionAmount(val)}
                            />
                          ) : (
                            <span>{value.toFixed(2)}</span>
                          ),
                      },
                      {
                        title: "Action",
                        render: (_, record, index) =>
                          editingDeductionIndex === index ? (
                            <Button
                              type="link"
                              icon={<CheckOutlined />}
                              onClick={() => {
                                const updated = [...deductions];
                                updated[index].amount = editedDeductionAmount || record.amount;
                                setDeductions(updated);
                                setEditingDeductionIndex(null);
                                setEditedDeductionAmount(null);
                              }}
                            />
                          ) : (
                            <Button
                              type="link"
                              icon={<EditOutlined />}
                              onClick={() => {
                                setEditingDeductionIndex(index);
                                setEditedDeductionAmount(record.amount);
                              }}
                            />
                          ),
                      },
                    ]}
                    rowKey={(record, index) => index}
                    pagination={false}
                  />
         
         {!(payrollStatus === "paid" || payrollStatus === "approved") && (
                <Button
                  type="dashed"
                  onClick={addDeduction}
                  icon={<PlusOutlined />}
                  style={{ marginTop: "10px" }}
                >
                  Add Deduction
                </Button>
              )}

                </div>
              </div>

              {/* Summary */}
              <div className="row">
                <div className="col-md-6">
                  <h6>Total Earnings:</h6> ₹{totalEarnings.toFixed(2)}
                </div>
                <div className="col-md-6 text-end">
                  <h6>Total Deductions:</h6> ₹{totalDeductions.toFixed(2)}
                </div>
                <div className="col-md-12 text-center mt-3">
                  <h5>Net Pay: ₹{netPay.toFixed(2)}</h5>
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={onClose}
              >
                Close
              </button>
              {!(payrollStatus === "paid" || payrollStatus === "approved") && (
            <button className="btn btn-primary" type="submit">
              Save
            </button>
          )}
            </div>
          </form>
        </div>
      </div>
    </div>

  );
};

export default ViewSalaryDetails;
